import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=6936df41"
import script from "../../controllers/chat/chat-history.js?vue&type=script&lang=js&external"
export * from "../../controllers/chat/chat-history.js?vue&type=script&lang=js&external"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=6936df41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports